import router from './route';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import './infrastructure/i18n/index';

// Sentry
import './instrument';

// Styles
import './assets/style.css';
import './assets/satoshi.css';
import './assets/simple-datatables.css';
import 'flatpickr/dist/flatpickr.min.css';
import 'nouislider/dist/nouislider.css';
import 'dropzone/dist/dropzone.css';
import 'react-toastify/dist/ReactToastify.css';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <RouterProvider router={router} />
    <ToastContainer
      hideProgressBar
      closeOnClick
      pauseOnHover
      autoClose={2000}
    />
  </Provider>,
);
